import type { AxiosInstance } from 'axios'
import type {
    ILoginResponse,
    IResetPasswordInitResponse,
    IResetPasswordSetPasswordResponse,
    IResetPasswordValidateTokenResponse,
} from '@/typings/auth'
import { OK_CODE } from '@/config/httpCodes.ts'

export default (axios: AxiosInstance) => ({
    login: async ({
        email,
        password,
    }: {
        email: string
        password: string
    }): Promise<{ token: string }> => {
        const {
            data: { token },
        } = await axios.post<ILoginResponse>(
            'guardian/login_check',
            {
                username: email,
                password,
            },
            {
                omitAuthorization: true,
            },
        )

        return { token }
    },

    logout: async (): Promise<boolean> => {
        const { status } = await axios.post('/guardian/logout')

        return status === OK_CODE
    },

    resetPasswordInit: async (email: string): Promise<{ isSuccess: boolean; message: string }> => {
        const {
            status,
            data: { message },
        } = await axios.put<IResetPasswordInitResponse>(
            '/guardian/reset-password',
            {
                email,
            },
            {
                omitAuthorization: true,
            },
        )

        return {
            isSuccess: status === OK_CODE,
            message,
        }
    },

    resetPasswordSetPassword: async ({
        token,
        password,
        passwordConfirm,
    }: {
        token: string
        password: string
        passwordConfirm: string
    }): Promise<boolean> => {
        const { status } = await axios.post<IResetPasswordSetPasswordResponse>(
            '/guardian/reset-password/change-password',
            {
                token,
                newPassword1: password,
                newPassword2: passwordConfirm,
            },
            {
                omitAuthorization: true,
            },
        )

        return status === OK_CODE
    },

    resetPasswordValidateToken: async (token: string): Promise<boolean> => {
        const { status } = await axios.put<IResetPasswordValidateTokenResponse>(
            `/guardian/reset-password/reset/`,
            undefined,
            {
                omitAuthorization: true,
                params: {
                    token,
                },
            },
        )

        return status === OK_CODE
    },
})
